import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const anesthesiaApi = {
  getEval: async (uhid) => {
    const response = await api.get(`/get_anesthesia_form/${uhid}`);
    return response.data;
  },

  createEval: async (data) => {
    const response = await api.post('/anesthesia_form', data);
    return response.data;
  },

  updateEval: async (uhid, data) => {
    const response = await api.put(`/update_anesthesia_form/${uhid}`, data);
    return response.data;
  }
};
